module.exports = __webpack_public_path__ + "static/media/Battle Dwarf.b9c9cd7e.jpg";